export { formatarDocumento, formatarCompetencia, competenciaAtual } from '@sgc/contracts';
import type { Periodicidade, RegimeTributario, SituacaoCliente } from '@sgc/contracts';

export const ROTULO_REGIME: Record<RegimeTributario, string> = {
  SIMPLES: 'Simples Nacional', MEI: 'MEI', PRESUMIDO: 'Lucro Presumido', REAL: 'Lucro Real', IMUNE_ISENTA: 'Imune / Isenta', PF: 'Pessoa Física',
};
export const OPCOES_REGIME = Object.entries(ROTULO_REGIME) as Array<[RegimeTributario, string]>;

export const ROTULO_SITUACAO: Record<SituacaoCliente, string> = { ATIVA: 'Ativa', SUSPENSA: 'Suspensa', BAIXADA: 'Baixada' };
export const OPCOES_SITUACAO = Object.entries(ROTULO_SITUACAO) as Array<[SituacaoCliente, string]>;

/** dd/mm — para cartões e células estreitas; o ano só aparece quando não é o corrente. */
export function fmtDataCurta(iso: string | null | undefined): string {
  const completa = fmtData(iso);
  return completa.endsWith(`/${new Date().getFullYear()}`) ? completa.slice(0, 5) : completa;
}

export function fmtData(iso: string | null | undefined): string {
  if (!iso) return '';
  const [a, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
}

/** "mm/aaaa" ou "aaaamm" → AAAAMM; null se inválido. */
/**
 * Máscara de competência enquanto digita: "092026" → "09/2026", "202609" → "09/2026", "9/2026" fica.
 * Só reorganiza dígitos; nunca inventa mês nem ano.
 */
export function mascaraCompetencia(v: string): string {
  const limpo = v.replace(/[^\d/]/g, '');
  // AAAAMM digitado de uma vez (ex.: 202609, mesmo que a barra já tenha entrado como 20/2609): ano 19xx/20xx + mês válido
  const so = limpo.replace(/\D/g, '');
  if (so.length === 6 && Number(so.slice(0, 2)) > 12 && /^(19|20)\d{2}$/.test(so.slice(0, 4)) && Number(so.slice(4, 6)) >= 1 && Number(so.slice(4, 6)) <= 12) return `${so.slice(4, 6)}/${so.slice(0, 4)}`;
  if (limpo.includes('/')) {
    const [a = '', b = ''] = limpo.split('/');
    return `${a.replace(/\D/g, '').slice(0, 2)}/${b.replace(/\D/g, '').slice(0, 4)}`;
  }
  const d = limpo.slice(0, 6);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}/${d.slice(2)}`;
}

/** Máscara de data curta dd/mm/aaaa enquanto digita. */
export function mascaraData(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

export function lerCompetencia(txt: string): number | null {
  const t = txt.trim();
  let m = t.match(/^(\d{1,2})\/(\d{4})$/);
  if (m) { const mes = Number(m[1]); return mes >= 1 && mes <= 12 ? Number(m[2]) * 100 + mes : null; }
  m = t.match(/^(\d{4})(\d{2})$/);
  if (m) { const mes = Number(m[2]); return mes >= 1 && mes <= 12 ? Number(m[1]) * 100 + mes : null; }
  return null;
}

export const ROTULO_PERIODICIDADE: Record<Periodicidade, string> = {
  MENSAL: 'Mensal', TRIMESTRAL: 'Trimestral', QUADRIMESTRAL: 'Quadrimestral', SEMESTRAL: 'Semestral', ANUAL: 'Anual', EVENTUAL: 'Por evento',
};
